
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"900","height":"600","viewBox":"0 0 90 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M90 0H0v60z","fill":"#003580"}}),_c('path',{attrs:{"d":"M0 60h90V0z","fill":"#009543"}}),_c('path',{attrs:{"d":"M0 60L90 0","stroke":"#fff","stroke-width":"20"}}),_c('path',{attrs:{"d":"M0 60L90 0","stroke":"#d21034","stroke-width":"15"}}),_c('g',{attrs:{"fill":"#ffce00","transform":"translate(18 16.341)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0 10l1.553-4.204h-3.106z"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(90)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(180)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(270)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(30)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(60)"}}),_c('circle',{attrs:{"r":"5.5","stroke":"#003580"}})])])
          )
        }
      }
    